import React, { useContext, useEffect, useState } from "react";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AuthContext from "../../context/auth/authContext";
import AddTripComposer from "../trips/AddTripComposer";

const CreateTrip = () => {
  const authContext = useContext(AuthContext);
  const { loadUser } = authContext;
  const [tab, setTab] = useState(0);

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: '100%', pt: 8 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {tab === 0 ? 'Create a Trip' : 'Plan a Trip'}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          {tab === 0
            ? 'Share a trip you\'ve already taken.'
            : 'Plan an upcoming trip. You can publish it later.'}
        </Typography>
      </Box>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 1, borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="Create Trip" sx={{ textTransform: 'none', fontWeight: 600 }} />
        <Tab label="Plan Trip" sx={{ textTransform: 'none', fontWeight: 600 }} />
      </Tabs>
      {tab === 0 && <AddTripComposer mode="public" />}
      {tab === 1 && <AddTripComposer mode="draft" />}
    </Box>
  );
};

export default CreateTrip;
